/*
 * Core CDN polyfills that should always be loaded.
 */
export default (ENVConfig, mode, min) => ({
    scripts: [
        {
            src: `https://cdn.jsdelivr.net/npm/react@${ENVConfig.VERSIONS['react']}/umd/react.${mode}${min}.js`,
            crossorigin: 'anonymous',
            enabledIf: () => !window.React,
            waitFor: 'React',
        }, {
            src: `https://cdn.jsdelivr.net/npm/react-dom@${ENVConfig.VERSIONS['react-dom']}/umd/react-dom.${mode}${min}.js`,
            crossorigin: 'anonymous',
            enabledIf: () => !window.ReactDOM,
            waitFor: 'ReactDOM',
        }, {
            src: 'https://cdn.jsdelivr.net/npm/whatwg-fetch@3.6.2/dist/fetch.umd.js',
            enabledIf: () => !window.fetch,
        }, {
            src: 'https://cdn.jsdelivr.net/npm/promise-polyfill@8.2.1/dist/polyfill.min.js',
            enabledIf: () => !window.Promise,
        }, {
            src: 'https://cdn.jsdelivr.net/npm/abortcontroller-polyfill@1.7.3/dist/abortcontroller-polyfill-only.js',
            enabledIf: () => !window.AbortController,
        }, {
            src: 'https://cdn.jsdelivr.net/npm/details-element-polyfill@2.4.0/dist/details-element-polyfill.js',
            enabledIf: () => !(typeof HTMLDetailsElement !== 'undefined' && document.createElement('details') instanceof HTMLDetailsElement),
        },
    ],
    stylesheets: [],
});
